import { render, staticRenderFns } from "./TempP17PrapaDebtReport.vue?vue&type=template&id=2803e45a&"
import script from "./TempP17PrapaDebtReport.vue?vue&type=script&lang=js&"
export * from "./TempP17PrapaDebtReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports